import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  PayrollInputSources,
  PayrollStartData,
  PayrollStatuses,
  PayTypes
} from '../../../../models/payroll';
import { Router } from '@angular/router';
import { PayrollService } from '../../../../services/payroll.service';
import { PayrollManagement } from '../../../../tools/payroll-management';
import { ClientSetup } from '../../../../models/client';
import { AppConfigService } from '../../../../services/app-config.service';
import { CompaniesService } from '../../../../services/companies.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'lib-adjustment-payroll-tile',
  templateUrl: './adjustment-payroll-tile.component.html',
  styleUrls: ['./adjustment-payroll-tile.component.css'],
  standalone: false
})
export class AdjustmentPayrollTileComponent implements OnInit {
  @Input() clientCode: string;
  @Input() clientSetup: ClientSetup;
  @Input() payrollStartData: PayrollStartData;

  get correctionPayrollInProgress() {
    return (
      this.payrollStartData.ActivePayroll &&
      this.payrollStartData.ActivePayroll.PayType == PayTypes.Adjustment
    );
  }

  get nonCorrectionPayrollInProgress() {
    return (
      this.payrollStartData.ActivePayroll &&
      this.payrollStartData.ActivePayroll.PayType != PayTypes.Adjustment
    );
  }

  // if there is a correction payroll in progress
  // disable resume if it is not same user or status is started/in progress
  get cannotResume() {
    if (!this.correctionPayrollInProgress) {
      return false;
    } else {
      return (
        !this.authService.isCurrentUser(this.payrollStartData.ActivePayroll.LastEditBy) &&
        this.payrollStartData.ActivePayroll.Status == PayrollStatuses.Started
      );
    }
  }

  get isTileDisabled() {
    return (
      this.clientSetup.HasMultipleLocations ||
      this.nonCorrectionPayrollInProgress ||
      !this.appConfigService.getConfig().EnableCorrectionPayrollLanding ||
      !this.payrollStartData?.OpenOrHeldQuarterPayrolls.length ||
      this.cannotResume ||
      this.startedInAPS
    );
  }

  get startedInAPS() {
    return (
      this.payrollStartData.ActivePayroll &&
      this.payrollStartData.ActivePayroll.InputSource != PayrollInputSources.API
    );
  }

  get buttonText() {
    if (this.correctionPayrollInProgress) {
      return 'Resume Corrections';
    }

    return 'Start Corrections';
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    public appConfigService: AppConfigService,
    @Inject('env') private env: any
  ) {}

  ngOnInit(): void {}

  //#region Public Methods

  public navigatePayroll() {
    this.router.navigate([`/client/${this.clientCode}/payroll-corrections`]);
  }

  //#endregion
}
